module.exports = __webpack_public_path__ + "static/media/PlaceOrder.34e41da5.svg";